import FormTemplateHelpers from "@helpers/form-template-helpers";
import {
    validateEmail,
    validateNumber
} from "@helpers/validation-helpers";

const buildFormValidationRules = (value, field) => {
    const rules = {
        required: value.required,
    }

    if (value.maxLength) {
        rules.maxLength = field.maxLength;
    }

    return rules;
};

const validateRequiredField = (value, field) => {
    if (!value.required) return true;
    const valueProperty = value.value;

    if (field.objecttype === 'formMultiple' ) {
        const {other, ...val} = valueProperty;

        if (Object.keys(val).length === 1 && Object.values(val)[0] === '-') {
            return false;
        }

        return Object.keys(val).length > 0;
    }

    return valueProperty.text && valueProperty.text.length > 0;
};

const validateMaxLengthField = (value, field) => {
    if (!field?.content?.maxLength) return true;
    const valueProperty = value.value;

    if (field.objecttype === 'formText' && valueProperty?.text) {
        return valueProperty.text.length <= field.content.maxLength;
    }

    return true;
};

const validateEmailField = (value, field) => {
    if (field.objecttype !== 'formText' || field?.content?.choiceType !== 'email') return true;

    const valueProperty = value.value;

    if (valueProperty?.text) {
        return validateEmail(valueProperty.text);
    }

    return true;
};

const validateNumberField = (value, field) => {
    if (field.objecttype !== 'formText' || (field?.content?.choiceType !== 'number' && field?.content?.choiceType !== 'currency')) return true;

    const valueProperty = value.value;

    if (valueProperty?.text) {
        return validateNumber(valueProperty.text);
    }

    return true;
};

const validateField = (value, field) => {
    const errors = [];

    if (!validateRequiredField(value, field)) {
        errors.push("This field is required.");
    }

    if (!validateMaxLengthField(value, field)) {
        errors.push(`This field allows a maximum of ${field.content.maxLength} characters.`);
    }

    if (!validateEmailField(value, field)) {
        errors.push(`This field must be a valid email address.`);
    }

    if (!validateNumberField(value, field)) {
        errors.push(`This field must be a valid number. Examples of valid numbers include: "123", "1,23.45", "-1.23" and "1.23e-5"`);
    }

    if (errors.length > 0) {
        return errors;
    }

    return true;
};

/**
 *
 * @param values
 * @param fields
 * @param onFail
 * @returns {boolean|*[]}
 */
const validateFields = (values, fields, onFail = (field, answerIndex, validationResult) => {}) => {
    const failures = [];

    for (const fieldId in values) {
        const field = FormTemplateHelpers.getFieldById(fieldId, fields);
        if (FormTemplateHelpers.fieldIsHeader(field)) continue;

        for (const answerIndex of Object.keys(values[fieldId])) {
            if (!values[fieldId][answerIndex].visible) continue;

            const validationResult = FormValidationHelpers.validateField(values[fieldId][answerIndex], field);

            if (validationResult !== true) {
                failures.push({
                    field,
                    answerIndex,
                    validationResult,
                })

                onFail(
                    field,
                    answerIndex,
                    validationResult,
                );
            }
        }
    }

    if (failures.length === 0) {
        return true;
    }

    return failures;
}

const FormValidationHelpers = {
    buildFormValidationRules,
    validateRequiredField,
    validateMaxLengthField,
    validateEmailField,
    validateNumberField,
    validateField,
    validateFields
}

export default FormValidationHelpers;

export {
    buildFormValidationRules,
    validateRequiredField,
    validateMaxLengthField,
    validateEmailField,
    validateNumberField,
    validateField,
    validateFields
}